export const LeftIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.7071 20.7071C16.3166 21.0976 15.6834 21.0976 15.2929 20.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289C17.0976 3.68342 17.0976 4.31658 16.7071 4.70711L9.41421 12L16.7071 19.2929C17.0976 19.6834 17.0976 20.3166 16.7071 20.7071Z'
        fill='#121212'
      />
    </svg>
  );
};

export const DownIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.85396 9.81075L3.53415 5.49094C3.2738 5.23059 2.85169 5.23059 2.59134 5.49094L2.44992 5.63236C2.18957 5.89271 2.18957 6.31482 2.44992 6.57517L7.85396 11.9792L13.258 6.57517C13.5184 6.31482 13.5184 5.89271 13.258 5.63236L13.1166 5.49094C12.8562 5.23059 12.4341 5.23059 12.1738 5.49094L7.85396 9.81075Z'
        fill='black'
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.753 19.2752L9.30859 14.2752L10.5543 13.168L14.9987 18.168L13.753 19.2752Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.59787 4.55534C3.98986 4.55534 1.87565 6.66955 1.87565 9.27756C1.87565 11.8856 3.98986 13.9998 6.59787 13.9998C9.20588 13.9998 11.3201 11.8856 11.3201 9.27756C11.3201 6.66955 9.20588 4.55534 6.59787 4.55534ZM0.208984 9.27756C0.208984 5.74907 3.06939 2.88867 6.59787 2.88867C10.1264 2.88867 12.9868 5.74907 12.9868 9.27756C12.9868 12.806 10.1264 15.6664 6.59787 15.6664C3.06939 15.6664 0.208984 12.806 0.208984 9.27756Z'
        fill='black'
      />
      <path
        d='M13.043 4.58629C15.2204 4.58629 16.5268 2.99538 16.5268 0.722656C16.5268 2.99538 18.051 4.58629 19.793 4.58629C18.051 4.58629 16.5268 5.94993 16.5268 8.22266C16.5268 5.94993 15.2204 4.58629 13.043 4.58629Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.3197 3.25929C15.8456 2.66042 16.1518 1.78933 16.1518 0.722656H16.9018C16.9018 2.83551 18.3024 4.21129 19.793 4.21129V4.96129C18.2731 4.96129 16.9018 6.14173 16.9018 8.22266H16.1518C16.1518 7.15706 15.8466 6.35012 15.3307 5.81163C14.8167 5.27518 14.0518 4.96129 13.043 4.96129V4.21129C14.034 4.21129 14.7986 3.85264 15.3197 3.25929ZM14.832 4.56415C15.2279 4.74153 15.5774 4.985 15.8722 5.29278C16.1533 5.58615 16.3776 5.93048 16.5442 6.31849C16.9112 5.51671 17.5104 4.91589 18.2334 4.56508C17.5071 4.17351 16.9103 3.51207 16.5448 2.67289C16.38 3.07627 16.159 3.44019 15.8832 3.7542C15.5877 4.0907 15.2347 4.36355 14.832 4.56415Z'
        fill='black'
      />
    </svg>
  );
};
